import { computed, ref } from 'vue';
import { APP_ELEMENT_ID } from '../models/constants';

import { useStore } from './store.composable';

import { AemFormComposable } from '../models/entities/aem-forms.model';

import AEMFormsService from '../services/aem-forms.service';
import CiamService from '../services/ciam.service';

const useAemForm = (): AemFormComposable => {
  const { commit, state, getter, dispatch } = useStore();

  const formRenderKey = ref(0);

  // computed
  const appId = computed(() => {
    return APP_ELEMENT_ID;
  });

  const formInitialData = computed(() => {
    const wkoUserData = state?.otbcUser?.wkoUserData;
    const b2xCoreProfile = state?.otbcUser?.b2xCoreProfile;
    const prospect = state.otbcFlow?.prospect;

    let formsValues: any = [];
    if (prospect?.customerNameSet) {
      formsValues = AEMFormsService.getFormInitialDataFromProspect(prospect);
    }
    if (b2xCoreProfile || wkoUserData) {
      formsValues =
        AEMFormsService.processFormInitialDataForSeamlessLocalStorageLogic(
          b2xCoreProfile ?? wkoUserData,
          formsValues
        );
    }
    return JSON.stringify(formsValues);
  });

  const aemRequestFormLink = computed(() => {
    if (getter?.isTestDriveFromHomeEnabled) return getter.aemTdFromHomeForm;
    return getter.aemRequestForm;
  });

  const aemFormsResources = computed(() => {
    return [getter.aemFormsEndpoint];
  });

  // methods

  /* This is the go to solution in Vue to force rerender
  of an element. This works by updating the "key" attribute
  of that element, which will consider a new instance and rerender.
  This is useful when we want to open the AEM Form to change the personal
  data, on the Request mode, as an example. */
  const renderForm = (): void => {
    formRenderKey.value++;
  };

  const storeProspectBeforeSendData = async (
    formValues: any
  ): Promise<void> => {
    let prospect = null;

    if (state.otbcUser.token) {
      prospect = state.otbcFlow.prospect;
    } else {
      prospect = await CiamService.getCiamIdByEmailAndBuildProspect(
        formValues.email
      );
    }

    await commit(
      'prospect',
      AEMFormsService.buildProspect(
        state.configuration.aemFormsHandlerConfig,
        formValues,
        prospect
      )
    );
  };

  const sendAemForm = async (): Promise<void> => {
    await dispatch('sendAemForm', state.configuration);
  };

  return {
    appId,
    formInitialData,
    aemRequestFormLink,
    aemFormsResources,
    formRenderKey,
    renderForm,
    storeProspectBeforeSendData,
    sendAemForm,
  };
};

export default useAemForm;
